import React from 'react';
const MAX_LENGTH = 50;
const truncate = (str, maxLength) => {
    if (str && str.length > maxLength) {
        return `${str.substring(0, maxLength)}...`;
    }
    return str;
};
export default function LinkDetailStrategy() {
    return {
        appliesTo: (key) => key === 'alternative_payment_link',
        render: (key, newValue, oldValue) => {
            const oldLink = oldValue;
            const newLink = newValue;
            return (React.createElement("span", { key: key, className: "link-detail-strategy" },
                "The ",
                key.replace(/_/g, ' '),
                " field was changed from",
                ' ',
                React.createElement("a", { href: oldLink, target: "_blank", rel: "noopener noreferrer", className: "qmb-link" }, truncate(oldLink, MAX_LENGTH)),
                ' ',
                "to",
                ' ',
                React.createElement("a", { href: newLink, target: "_blank", rel: "noopener noreferrer", className: "qmb-link" }, truncate(newLink, MAX_LENGTH))));
        }
    };
}
